import PatientDashboard from './PatientDashboard';

export default PatientDashboard;
